var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.364,
    height: 15.761,
    viewBox: "0 0 50.364 15.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(0 -100.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797",
    transform: "translate(4.706 100.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7025",
    "data-name": "Path 7025",
    d: "M43.142,100.23l-2.528,15.729h4.04l2.526-15.729Zm12.186,6.407c-1.412-.7-2.277-1.168-2.277-1.881.017-.648.732-1.313,2.328-1.313a7.031,7.031,0,0,1,3.009.582l.367.164L59.3,100.9a10.2,10.2,0,0,0-3.626-.648c-3.99,0-6.8,2.074-6.816,5.041-.033,2.189,2.011,3.4,3.541,4.133,1.563.748,2.095,1.232,2.095,1.9-.017,1.02-1.264,1.49-2.427,1.49A8.216,8.216,0,0,1,48.28,112l-.532-.242-.565,3.42a12.617,12.617,0,0,0,4.506.812c4.24,0,7-2.043,7.034-5.2C58.736,109.052,57.658,107.723,55.329,106.637Zm14.333-6.359H66.536a2,2,0,0,0-2.112,1.265l-6,14.415h4.24l1.168-3.121h4.744l.606,3.134h3.74Zm-4.655,9.41c.082.008,1.627-5.095,1.627-5.095l1.231,5.095ZM37.239,100.23,33.28,110.917l-.431-2.107a11.743,11.743,0,0,0-5.587-6.387l3.625,13.521h4.275l6.352-15.712H37.239Z",
    transform: "translate(-27.262 -100.23)",
    fill: "#00579f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7026",
    "data-name": "Path 7026",
    d: "M8.962,102.273a2.64,2.64,0,0,0-2.628-2.025H.065L0,100.539c4.89,1.206,8.995,4.915,10.326,8.4Z",
    transform: "translate(0 -0.015)",
    fill: "#faa61a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0a1b772f7c682f00725c1724d5748cb0.svg";
export { ForwardRef as ReactComponent };